"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withoutChangeListener = exports.withChangeListener = exports.getRouteAndParamsFromHash = void 0;
var getTokens = function (hash) {
    return hash
        .split('/')
        .filter(Boolean)
        .filter(function (element) { return element !== '#'; });
};
var isParameterRouteToken = function (token) {
    if (token.indexOf('<') !== 0 ||
        !token.slice(2, -4).includes(':') ||
        token.indexOf('>') !== token.length - 1) {
        return false;
    }
    var _a = token
        .slice(token.indexOf('<') + 1, token.indexOf('>'))
        .split(':'), type = _a[1];
    if (!['int', 'string', 'number'].includes(type)) {
        return false;
    }
    return true;
};
var parseParameterRouteToken = function (token) {
    var _a = token
        .slice(token.indexOf('<') + 1, token.indexOf('>'))
        .split(':'), parameter = _a[0], type = _a[1];
    return {
        parameter: parameter,
        type: type,
    };
};
var isNumber = function (possiblyNumber) { return !isNaN(Number(possiblyNumber)); };
var isInt = function (possiblyInt) {
    return (isNumber(possiblyInt) && parseInt(possiblyInt, 10) === Number(possiblyInt));
};
var appendTokenToHash = function (hash, token) { return hash + "/" + token; };
var getMatch = function (hash, route) {
    var hashTokens = getTokens(hash);
    var routeTokens = getTokens(route);
    var params = {};
    var reconstructedHash = '#';
    if (hashTokens.length !== routeTokens.length)
        return false;
    for (var _i = 0, _a = Object.keys(hashTokens); _i < _a.length; _i++) {
        var i = _a[_i];
        var hashToken = hashTokens[Number(i)];
        var routeToken = routeTokens[Number(i)];
        if (isParameterRouteToken(routeToken)) {
            var _b = parseParameterRouteToken(routeToken), parameter = _b.parameter, type = _b.type;
            if (type === 'int') {
                if (!isInt(hashToken))
                    return false;
                params[parameter] = parseInt(hashToken, 10);
                reconstructedHash = appendTokenToHash(reconstructedHash, hashToken);
            }
            else if (type === 'number') {
                if (!isNumber(hashToken))
                    return false;
                params[parameter] = Number(hashToken);
                reconstructedHash = appendTokenToHash(reconstructedHash, hashToken);
            }
            else if (type === 'string') {
                params[parameter] = hashToken;
                reconstructedHash = appendTokenToHash(reconstructedHash, hashToken);
            }
        }
        else {
            if (hashToken !== routeToken)
                return false;
            reconstructedHash = appendTokenToHash(reconstructedHash, hashToken);
        }
    }
    return { params: params, reconstructedHash: reconstructedHash };
};
exports.getRouteAndParamsFromHash = function (hash, routePatterns) {
    for (var _i = 0, routePatterns_1 = routePatterns; _i < routePatterns_1.length; _i++) {
        var routePattern = routePatterns_1[_i];
        var match = getMatch(hash, routePattern);
        if (match) {
            var params = match.params, reconstructedHash = match.reconstructedHash;
            var route = reconstructedHash.substr(1);
            return { route: route, routePattern: routePattern, params: params, reconstructedHash: reconstructedHash };
        }
    }
    return { route: '', routePattern: '', params: {}, reconstructedHash: '' };
};
exports.withChangeListener = function (changeListeners, changeListenerToBeAdded) {
    return __spreadArrays(changeListeners, [changeListenerToBeAdded]);
};
exports.withoutChangeListener = function (changeListeners, changeListenerToBeRemoved) {
    return changeListeners.filter(function (changeListener) { return changeListener !== changeListenerToBeRemoved; });
};
